import React, { TableRow, TableCell, Collapse } from '@mui/material';
import { useState } from 'react';
import { Collapser, ProductForm } from 'components';
import { ProductsRowProps } from './ProductRowProps';



export const ProductRow = ({ row }: ProductsRowProps) => {
	const [open, setOpen] = useState(false);
	return (
		<>
			<TableRow
				sx={{ '& > *': { borderBottom: 'unset' } }}
				onClick={() => {
					setOpen(!open);
				}}
			>
				<TableCell>
					<Collapser isAdd={false} open={open} />
				</TableCell>
				<TableCell colSpan={2}>{row.name}</TableCell>
				<TableCell colSpan={4}>{row.basePrice}</TableCell>
				<TableCell colSpan={4}>{row.bonusPoints}</TableCell>
			</TableRow>
			<TableRow>
				<TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={10}>
					<Collapse in={open} timeout='auto'>
						<ProductForm product={row} />
					</Collapse>
				</TableCell>
			</TableRow>
		</>
	);
}
